/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_W2Inputs */

const en_mk_cmp_multica_w2 = /** @type {(inputs: Mk_Cmp_Multica_W2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want to run it on your own servers and have someone able to maintain it.`)
};

const id_mk_cmp_multica_w2 = /** @type {(inputs: Mk_Cmp_Multica_W2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda ingin memasang sendiri di server Anda dan punya orang yang sanggup merawatnya.`)
};

/**
* | output |
* | --- |
* | "You want to run it on your own servers and have someone able to maintain it." |
*
* @param {Mk_Cmp_Multica_W2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_w2 = /** @type {((inputs?: Mk_Cmp_Multica_W2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_W2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_w2(inputs)
	return en_mk_cmp_multica_w2(inputs)
});